import { render, staticRenderFns } from "./latest-sessions.vue?vue&type=template&id=1130a0ba&"
import script from "./latest-sessions.vue?vue&type=script&lang=ts&"
export * from "./latest-sessions.vue?vue&type=script&lang=ts&"
import style0 from "./latest-sessions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports